import 'stacktable.js/stacktable.js';

(function($, Drupal) {
  'use strict';

  Drupal.behaviors.stacktable = {
    attach: function(context, settings) {
      let $body_field = $('.field--name-body');
      if ($body_field) {
        let $tables = $('.field--name-body', context).find('table');

        $tables.once('alter-tables').each(function(index) {
          // Find all 'repsonsive tables' and add id's
          $(this).attr('id', 'responsive-table-' + index);
          $('#responsive-table-' + index).stackcolumns();
        });
      }

      // 'person' paremeter in url set select to that value
      let url = new URL(window.location.href);
      let person = url.searchParams.get('person');
      if (person) {
        $('.js-form-item-faculty-association').hide();
        $('.js-form-item-person').show();
      }

      $('#edit-faculty-association').on('change', function() {
        $('#edit-person').val($('#edit-faculty-association').val());
      });

      $('#edit-person').on('change', function() {
        $('#edit-faculty-association').val($('#edit-person').val());
      });
    }
  };
})(jQuery, Drupal);
